import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Tekis inset hairline border (Figma standarti). false bo'lsa borbersiz. */
  hairline?: boolean;
  /** Yarim iliq sirt (stat tile'lar uchun — Figma surface-warm). */
  warm?: boolean;
}

/**
 * Sirt kartasi — Figma §4/§5.4. Drop-shadow EMAS, inset hairline border.
 * radius 20 (r-lg). Fon `var(--c-surface)` (oq / dark karta).
 */
export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { hairline = true, warm = false, className, style, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      style={{
        background: warm ? "var(--c-surface-warm)" : "var(--c-surface)",
        boxShadow: hairline ? "inset 0 0 0 1px var(--c-line)" : undefined,
        ...style,
      }}
      className={cn("rounded-[20px]", className)}
      {...rest}
    >
      {children}
    </div>
  );
});
